import { isPlainObject as _isPlainObject } from 'lodash';
import timelineSelectors from './selectors';
import common from '../../_common/selectors';
/**
 * TODO tests
 * For each layer defined in layerRow.items and its periods execute callback with parameters [layer, mapLayerDefinition, period||periodKey]
 * @param {Object} state
 * @param {Object} layerRow
 * @param {function} callback
 */

export var forEachPeriodAndLayerInLayerRow = function forEachPeriodAndLayerInLayerRow(state, layerRow, callback) {
  var _layerRow$items;

  var activeKeys = common.getAllActiveKeys(state);
  layerRow === null || layerRow === void 0 ? void 0 : (_layerRow$items = layerRow.items) === null || _layerRow$items === void 0 ? void 0 : _layerRow$items.forEach(function (timelineLayer) {
    var _timelineLayer$period;

    //iterate over layer periods defined in array
    if ((timelineLayer === null || timelineLayer === void 0 ? void 0 : (_timelineLayer$period = timelineLayer.periods) === null || _timelineLayer$period === void 0 ? void 0 : _timelineLayer$period.length) > 0) {
      timelineLayer === null || timelineLayer === void 0 ? void 0 : timelineLayer.periods.forEach(function (timelineLayerPeriodItem) {
        var timelineMapLayerDefinition = timelineSelectors.getTimelineMapLayerPeriodDefinition(timelineLayer.layerState, timelineLayerPeriodItem === null || timelineLayerPeriodItem === void 0 ? void 0 : timelineLayerPeriodItem.key, activeKeys);
        callback(timelineLayer, timelineMapLayerDefinition, timelineLayerPeriodItem);
      });
    } else if (_isPlainObject(timelineLayer === null || timelineLayer === void 0 ? void 0 : timelineLayer.periods)) {
      // iterate over layer periods defined by period filter
      var periodsConfig = timelineLayer.periods; // fixme
      // should be shared variable also for selector

      var order = null;
      var start = 0;
      var length = 1000;
      var periodKeys = timelineSelectors.getPeriodKeysForFilteredSpatialRelations(state, periodsConfig.filterByActive, periodsConfig.filter, order, start, length) || [];
      periodKeys.forEach(function (periodKey) {
        var timelineMapLayerDefinition = timelineSelectors.getTimelineMapLayerPeriodDefinition(timelineLayer.layerState, periodKey, activeKeys);
        callback(timelineLayer, timelineMapLayerDefinition, periodKey);
      });
    }
  });
};